<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant="mini"
    width="300"
    mini-variant-width="140"
    app
    clipped
    hide-overlay
    :disable-resize-watcher="true"
    :permanent="true"
    :mobile-break-point="0 "
  >
    <v-btn class="btn-close" icon @click.stop="toggleMini">
      <v-icon v-show="!mini">chevron_left</v-icon>
      <v-icon v-show="mini">chevron_right</v-icon>
    </v-btn>
    <div class="sidebar-title">Layer</div>
    <div class="sidebar-list">
      <draggable v-model="sortedLayers" group="layers" handle=".draghandler" @start="drag=true" @end="drag=false">
        <div
          class="entry"
          v-for="layer in sortedLayers"
          :key="layer.title"
        >
          <button class="btn-icon-only icon-trash-small"
                  v-if="layer.type === 'wms'"
                  @click="deleteLayer(layer)"></button>
          <v-tooltip bottom>
            <template #activator="{ on }">
              <button v-on="on"
                      class="btn-icon-only icon-lock"
                      v-if="layer.type !== 'wms' && (!layer.metadataEditable || !layer.vectorEditable || !layer.objectsAdoptable)"></button>
            </template>
            <span v-if="!layer.metadataEditable">Layer für die Bearbeitung von Daten gesperrt<br/></span>
            <span v-if="!layer.vectorEditable">Layer für die Bearbeitung des Vektors gesperrt<br/></span>
            <span v-if="!layer.vectorAdoptable">Layer als Basisvektor für die Erstellung nicht verfügbar</span>
          </v-tooltip>
          <v-icon class="draghandler">drag_indicator</v-icon>
          <checkbox :label="layer.title"
                    :data="layer"
                    :value="isSelected(layer.id)"
                    @input="$emit('selectLayer',{layer, value: $event})"
                    class="sr-checkbox">
            <template #label="slotProps">
              <label :for="slotProps.id">
                <i></i>
                <span>
                                    <simple-svg
                                      :filepath="slotProps.data.iconUrl"
                                      :fill="slotProps.data.color"
                                      :stroke="slotProps.data.stroke"
                                    ></simple-svg>
                                    <div class="layer-title" :title="slotProps.label">{{ slotProps.label }}</div>
                                </span>
              </label>
            </template>
          </checkbox>
        </div>
      </draggable>
    </div>
    <div class="sidebar-buttons">
      <button @click="openWms" class="btn-icon green icon-plus"></button>
    </div>
    <div v-if="wms.show === true" class="sidebar-wms" v-bind:class="{ open: wms.show }">
      <button class="btn-icon icon-close" @click="closeWms"></button>
      <h3>WMS Layer</h3>
      <text-field
        :label="'URL'"
        :loading="wms.loading"
        v-model="wms.url">
      </text-field>

      <v-btn
        class="sr-button"
        text
        :loading="wms.loading"
        @click="saveWms"
      >
        WMS Layer anlegen
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
  import Draggable from 'vuedraggable'
  import LayerApi from '@/api/layer'
  import Wms from '@/components/dialog/content/Wms'
  import WmsFooter from '@/components/dialog/button/Wms'

  export default {
    props: {
      layers: {
        type: Array
      },
      selectedLayers: {
        type: Array
      }
    },
    components: { Draggable },
    data () {
      return {
        wms: {
          url: '',
          loading: false,
          prevMiniState: true,
          show: false
        },
        drawer: true,
        mini: true,
        icon: null
      }
    },
    methods: {
      toggleMini () {
        this.mini = !this.mini
        if (this.mini === true && this.wms.show === true) {
          this.wms.show = false
        }
      },
      openWms () {
        this.wms.show = true
        this.wms.prevMiniState = this.mini
        this.mini = false
      },
      closeWms () {
        this.wms.show = false
        this.mini = this.wms.prevMiniState
      },
      saveWms () {
        if (!this.wms.url) {
          this.$alert.error('Bitte geben Sie eine gültige URL ein')
          return false
        }

        if (this.wms.loading === true) {
          return false
        }

        this.wms.loading = true
        const url = encodeURIComponent(this.wms.url.trim())
        LayerApi.previewWmsImport(url)
          .then(response => {
            this.closeWms()
            this.wms.url = null
            // this.$alert.success('WMS erfolgreich importiert')
            this.$dialog.open({
              contentComponent: Wms,
              footerComponent: WmsFooter,
              title: 'Zu importierende Layer',
              message: 'Zu importierende Layer',
              contentOptions: {
                elements: response,
                layers: this.$store.getters['layer/getAll']
              },
              onConfirm: (dialog) => {
                this.wms.loading = true
                return LayerApi.createWmsImport(this.wms.url, dialog.contentData)
              },
              onConfirmError: (dialog, response) => {
                this.wms.loading = false
                this.showAjaxError(response)
              }
            }).then(r => {
              this.wms.loading = false
              if (r.confirmed === true) {
                this.$alert.success('Erfolgreich gespeichert')
                this.$store.dispatch('layer/fetchAll')
              }
            })
          })
          .catch(err => {
            this.showAjaxError(err)
          })
          .finally(() => {
            this.wms.loading = false
          })
      },
      showAjaxError (err) {
        if (typeof err.response.data.error !== 'undefined') {
          this.$alert.error(err.response.data.error)
          return
        }

        if (typeof err.response.data.message !== 'undefined') {
          this.$alert.error(err.response.data.message)
          return
        }

        this.$alert.error('Ein unerwarteter Fehler ist aufgetreten')
      },
      async deleteLayer (layer) {
        let result = await this.$dialog.delete({
          title: 'Layer löschen',
          message: `Sind Sie sicher, dass Sie <strong>${layer.title}</strong> löschen möchten?`,
          onConfirm: (dialog) => LayerApi.delete(layer.id),
          onConfirmError: (dialog, responseError) => this.$alert.info('Es sind Fehler beim löschen aufgetreten')
        })

        if (result && result.confirmed) {
          this.$alert.success('Layer erfolgreich gelöscht')
          this.$store.dispatch('layer/fetchAll')
        }
      },
      isSelected (layerId) {
        if (!this.selectedLayers.length) {
          return false
        }
        return !!this.selectedLayers.find(x => (x.id === layerId && x.active === true))
      }
    },
    computed: {
      sortedLayers: {
        get () {
          return this.layers
        },
        set (value) {
          this.$emit('layerUpdated', value)
        }
      }
    }
  }
</script>

<style scoped>
  .draghandler {
    cursor: grab;
  }
</style>
